import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink, httpLink } from "@trpc/client";
import { trpc } from "../../utils/trpc";
import superjson from "superjson";
import { getVisitorPublicId } from "./EnsureVisitorProvider.js";
import { getBrowserSessionId } from "./EnsureBrowserSessionIdProvider.js";

import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

const cacheTime = 1000 * 60 * 1; // 1 minute

const sessionStoragePersister = createSyncStoragePersister({
  storage: window.sessionStorage,
});

// use global window.Shopify.shop to get the shop name
// it also has locale, country, currency, theme

export default function TrpcProviderReact({
  children,
}: {
  children: ReactNode;
}) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // cacheTime: 1000 * 60 * 60 * 24, // 24 hours
        cacheTime: cacheTime,
      },
    },
  });

  persistQueryClient({
    queryClient: queryClient,
    persister: sessionStoragePersister,
    hydrateOptions: {},
    maxAge: cacheTime,
  });

  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpLink({
          url: `/apps/supabanner/api/trpc-open`,
          headers() {
            return {
              "x-supabanner-visitor-public-id": getVisitorPublicId(),
              "x-supabanner-source-url": window.location.href,
              "x-supabanner-browser-session-id": getBrowserSessionId(),
              // @ts-expect-error shopify is global
              "x-supabanner-shop": window.Shopify.shop,
            };
          },
        }),
      ],
      transformer: superjson,
    })
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
